import { render, staticRenderFns } from "./PaymentSuccess.vue?vue&type=template&id=aa18dd62&"
import script from "./PaymentSuccess.vue?vue&type=script&lang=js&"
export * from "./PaymentSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports